import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type", "style", "title", "seed"];
import { theme } from '../../utils/Styling';
import { clampNumber } from '../../utils/math';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const colorVariations = [{
  background: theme.colors.PANTERA,
  bubbles: [theme.colors.OZ, theme.colors.CALYPSO]
}, {
  background: theme.colors.OZ,
  bubbles: [theme.colors.PANTERA, theme.colors.SLINKY]
}, {
  background: theme.colors.CALYPSO,
  bubbles: [theme.colors.PANTERA, theme.colors.SLINKY]
}];
const getColorVariation = seed => {
  const colorVariation = colorVariations[seed % colorVariations.length];
  let bubbleColors = colorVariation.bubbles;
  let flipX = false;
  let flipY = false;
  if (seed % 2 === 1) {
    bubbleColors = [...bubbleColors].reverse();
  }
  if (seed % 4 === 1) {
    flipX = true;
  }
  if (seed % 8 === 1) {
    flipY = true;
  }
  return {
    background: colorVariation.background,
    bubbles: bubbleColors,
    flipX,
    flipY
  };
};
const RectangularImage = ({
  title,
  seed = 0
}) => {
  const {
    background,
    bubbles,
    flipX,
    flipY
  } = getColorVariation(seed);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    children: [/*#__PURE__*/_jsxs("svg", {
      fill: "none",
      height: "100%",
      style: {
        transform: `scale(${flipX ? -1 : 1}, ${flipY ? -1 : 1})`
      },
      viewBox: "0 0 800 450",
      width: "100%",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsxs("g", {
        clipPath: "url(#clip0_26_75)",
        children: [/*#__PURE__*/_jsx("rect", {
          fill: background,
          height: "450",
          width: "800"
        }), /*#__PURE__*/_jsx("path", {
          clipRule: "evenodd",
          d: "M857.878 701.556C861.438 686.394 956.836 576.008 788.095 482.6C619.354 389.192 391.886 154.998 301.429 401.868C210.972 648.739 -219.325 699.1 280.032 871.182C779.388 1043.26 854.318 716.719 857.878 701.556Z",
          fill: bubbles[0],
          fillOpacity: "0.2",
          fillRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          clipRule: "evenodd",
          d: "M984.998 146.104C984.998 146.104 899.275 -5.16438 748.279 120.596C597.282 246.357 710.507 281.455 484.143 422.401C257.778 563.348 699.413 702.038 835.476 683.957C971.538 665.876 984.998 146.104 984.998 146.104Z",
          fill: bubbles[1],
          fillOpacity: "0.2",
          fillRule: "evenodd"
        })]
      }), /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx("clipPath", {
          id: "clip0_26_75",
          children: /*#__PURE__*/_jsx("rect", {
            fill: "white",
            height: "450",
            width: "800"
          })
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        padding: '10%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: /*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        style: {
          color: 'white',
          fontSize: `${clampNumber(180 - ((title === null || title === void 0 ? void 0 : title.length) || 0) * 1.8, 100, 180)}%`,
          // scale font size based on title length
          textAlign: 'center',
          lineHeight: '120%'
        },
        children: title
      })
    })]
  });
};
const SquareImage = ({
  title,
  seed = 0
}) => {
  const {
    background,
    bubbles,
    flipX,
    flipY
  } = getColorVariation(seed);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    children: [/*#__PURE__*/_jsxs("svg", {
      fill: "none",
      height: "100%",
      style: {
        transform: `scale(${flipX ? -1 : 1}, ${flipY ? -1 : 1})`
      },
      viewBox: "0 0 100 100",
      width: "100%",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/_jsxs("g", {
        clipPath: "url(#clip0_27_94)",
        children: [/*#__PURE__*/_jsx("rect", {
          fill: background,
          height: "100",
          width: "100"
        }), /*#__PURE__*/_jsx("path", {
          clipRule: "evenodd",
          d: "M150.268 164.906C151.127 161.25 174.129 134.634 133.443 112.112C92.756 89.5898 37 51.5 10.9394 103C-10.8714 162.525 -109.464 164.314 10.9394 205.806C131.343 247.298 149.41 168.562 150.268 164.906Z",
          fill: bubbles[0],
          fillOpacity: "0.2",
          fillRule: "evenodd"
        }), /*#__PURE__*/_jsx("path", {
          clipRule: "evenodd",
          d: "M173.913 18.288C173.913 18.288 153.244 -18.1854 116.836 12.1378C80.428 42.4609 107.729 50.9236 53.148 84.9083C-1.43253 118.893 105.053 152.334 137.861 147.974C170.668 143.614 173.913 18.288 173.913 18.288Z",
          fill: bubbles[1],
          fillOpacity: "0.2",
          fillRule: "evenodd"
        })]
      }), /*#__PURE__*/_jsx("defs", {
        children: /*#__PURE__*/_jsx("clipPath", {
          id: "clip0_27_94",
          children: /*#__PURE__*/_jsx("rect", {
            fill: "white",
            height: "100",
            width: "100"
          })
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        position: 'absolute',
        padding: '10%',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      children: /*#__PURE__*/_jsx("span", {
        "aria-hidden": "true",
        style: {
          color: 'white',
          fontSize: '50%',
          textAlign: 'center',
          lineHeight: '120%'
        },
        children: title
      })
    })]
  });
};
const ACDynamicThumbnailImage = _ref => {
  let {
      type,
      style,
      title,
      seed
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const Image = type === 'square' ? SquareImage : RectangularImage;
  return /*#__PURE__*/_jsx("div", {
    style: style,
    children: /*#__PURE__*/_jsx(Image, Object.assign({
      seed: seed,
      title: title
    }, props))
  });
};
export default ACDynamicThumbnailImage;